import React, { useState, useEffect } from 'react';
import { Container, Button, Row, Col } from 'react-bootstrap';
import { processAssetsAndGenerateTemplates } from '../utils/dynamicTemplateEngine';
import '../DynamicTemplates.css';

function DynamicTemplateTest() {
    const [templates, setTemplates] = useState([]);
    const [showTemplates, setShowTemplates] = useState(false);

    // Sample test data
    const sampleAssets = [
        {
            _id: '1',
            type: 'Image',
            title: 'Beautiful Landscape',
            description: 'A stunning mountain view at sunrise',
            fileUrl: 'https://picsum.photos/800/600?random=1',
            url: 'https://picsum.photos/800/600?random=1'
        },
        {
            _id: '2',
            type: 'Image',
            title: 'City Skyline',
            description: 'Modern city architecture at night',
            fileUrl: 'https://picsum.photos/800/600?random=2',
            url: 'https://picsum.photos/800/600?random=2'
        },
        {
            _id: '3',
            type: 'Video Link',
            title: 'Product Demo',
            description: 'Watch our product in action',
            url: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ'
        },
        {
            _id: '4',
            type: 'PDF',
            title: 'User Manual',
            description: 'Complete guide to using our product',
            fileUrl: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
            url: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf'
        },
        {
            _id: '5',
            type: 'Contact',
            title: 'Customer Support',
            description: 'Get help from our support team',
            url: '+1-555-123-4567'
        }
    ];

    const sampleAIResponse = {
        headline: 'Amazing Content Collection',
        description: 'Discover our curated collection of assets and resources',
        faq: [
            {
                question: 'How do I use these assets?',
                answer: 'Simply browse through our collection and select the assets that best fit your needs. Each asset comes with detailed descriptions and usage guidelines.'
            },
            {
                question: 'Are these assets free to use?',
                answer: 'Yes, all assets in this collection are free to use for your projects. Please refer to our terms of service for any specific usage restrictions.'
            }
        ]
    };

    const generateTemplates = () => {
        const templateResult = processAssetsAndGenerateTemplates(
            sampleAssets, 
            'Create a showcase of our assets', 
            sampleAIResponse
        );
        
        setTemplates(templateResult.templates);
        setShowTemplates(true);

        // Render templates to DOM
        const container = document.getElementById('test-templates-container');
        if (container) {
            container.innerHTML = '';
            templateResult.templates.forEach(template => {
                if (template) {
                    container.appendChild(template);
                }
            });
        }
        
        // Log preview URLs for demonstration
        console.log('Generated Preview URLs:', templateResult.previewUrls);
        console.log('Total Sections:', templateResult.totalSections);
    };

    const clearTemplates = () => {
        setTemplates([]);
        setShowTemplates(false);
        const container = document.getElementById('test-templates-container');
        if (container) {
            container.innerHTML = '';
        }
    };

    return (
        <Container className="mt-4">
            <Row>
                <Col>
                    <h2>Dynamic Template System Test</h2>
                    <p className="text-muted">
                        This page demonstrates the dynamic template system for AI Asset Content Generator.
                        Click the button below to generate templates based on sample assets.
                    </p>
                    
                    <div className="mb-4">
                        <Button 
                            variant="primary" 
                            onClick={generateTemplates}
                            className="me-2"
                        >
                            Generate Dynamic Templates
                        </Button>
                        <Button 
                            variant="secondary" 
                            onClick={clearTemplates}
                        >
                            Clear Templates
                        </Button>
                    </div>

                    {showTemplates && (
                        <div>
                            <h4>Generated Templates ({templates.length})</h4>
                            <div id="test-templates-container" className="dynamic-templates-wrapper"></div>
                        </div>
                    )}

                    <div className="mt-5">
                        <h5>Sample Assets Used:</h5>
                        <ul>
                            {sampleAssets.map(asset => (
                                <li key={asset._id}>
                                    <strong>{asset.type}:</strong> {asset.title} - {asset.description}
                                </li>
                            ))}
                        </ul>
                    </div>
                </Col>
            </Row>
        </Container>
    );
}

export default DynamicTemplateTest;
